/**
 * Copyright 2022 Design Barn Inc.
 */

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import packageJson from '../../../package.json';

if (!Bugsnag.isStarted()) {
  Bugsnag.start({
    apiKey: process.env['NEXT_PUBLIC_BUGSNAG_API_KEY'] || '',
    plugins: [new BugsnagPluginReact()],
    enabledReleaseStages: ['production', 'staging', 'development'],
    releaseStage: process.env['NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE'] || 'development',
    appVersion: packageJson.version,
  });
}

export default Bugsnag;
